import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pt-0 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-1/4" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-4 mb-2"
}
const _hoisted_5 = { class: "relative flex justify-center overflow-auto h-screen" }
const _hoisted_6 = { class: "overflow-auto" }
const _hoisted_7 = {
  key: 1,
  style: {"margin-top":"-20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_SummaryCodCourier = _resolveComponent("SummaryCodCourier")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_PopupSetorHarian = _resolveComponent("PopupSetorHarian")!
  const _component_PopupHarusDisetor = _resolveComponent("PopupHarusDisetor")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Search, {
          onInput: _ctx.onSearch,
          onClear: _ctx.onClear,
          value: _ctx.searchValue,
          placeholder: _ctx.$t('codReconcile.list.searchPlaceholder'),
          class: "w-2/5"
        }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
        _createVNode(_component_DatePicker, {
          onSelected: _ctx.onSelectDatePicker,
          modelValue: _ctx.filterDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterDate = $event)),
          "max-date": new Date(),
          class: "w-1/3 mr-2"
        }, null, 8, ["onSelected", "modelValue", "max-date"]),
        _hoisted_3,
        _createVNode(_component_LpButton, {
          textColor: "white",
          title: _ctx.$t('codReconcile.list.downloadReconcile'),
          iconLeft: "download-new",
          iconV2: "",
          small: "",
          customClass: "w-full px-4 py-2",
          onClick: _ctx.downloadSummary
        }, null, 8, ["title", "onClick"])
      ]),
      (!_ctx.isLoadingSummary)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_SummaryCodCourier, { data: _ctx.summary }, null, 8, ["data"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (!_ctx.isErrorCourierPartner)
            ? (_openBlock(), _createBlock(_component_TableV2, {
                key: 0,
                ref: "tableCourierPartner",
                columns: _ctx.columns,
                firstRowHeader: _ctx.firstRowHeaderColumns,
                data: _ctx.dataCourierPartner,
                loading: _ctx.isLoadingCourierPartner,
                pagination: _ctx.paginationCourierPartner,
                "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => (_ctx.paginationCourierPartner = $event)),
                onRequest: _ctx.fetchListCourierPartner,
                groupOptions: _ctx.buttonActions,
                emptyHeaderMessage: _ctx.$t('codReconcile.list.emptyDexAutomationConfig'),
                emptyMessage: _ctx.$t('codReconcile.list.emptyDexAutomationConfigMessage'),
                groupAction: "",
                isNoPaddingBottom: "",
                paginationStyle: "v3",
                pinnedSubstractHeight: "535px",
                paginationWidth: "w-3/4",
                borderTop: false,
                borderBottom: false,
                iconColor: "green-lp-100",
                keyRowColor: "isHavePendingReconcile",
                rowColor: "bg-red-lp-1300",
                isRightFreeze: "",
                totalColumnFreeze: 1,
                bgHeader: "bg-white",
                bgHeaderCell: "bg-white",
                isBorderOnHeadBgWhite: "",
                infiniteScroll: "",
                isShowPagination: false
              }, null, 8, ["columns", "firstRowHeader", "data", "loading", "pagination", "onRequest", "groupOptions", "emptyHeaderMessage", "emptyMessage"]))
            : (_openBlock(), _createBlock("div", _hoisted_7, [
                (
              !_ctx.isLoadingCourierPartner &&
                _ctx.isErrorCourierPartner === 'notfound' &&
                _ctx.isFilter
            )
                  ? (_openBlock(), _createBlock(_component_EmptyState, {
                      key: 0,
                      icon: "noData_empty",
                      customHeaderMessage: _ctx.$t('codReconcile.list.emptyHeaderMessage'),
                      customMessage: _ctx.$t('codReconcile.list.emptyMessage')
                    }, null, 8, ["customHeaderMessage", "customMessage"]))
                  : (_openBlock(), _createBlock(_component_ErrorMessage, {
                      key: 1,
                      errorType: _ctx.isErrorCourierPartner,
                      customClass: "mt-10"
                    }, null, 8, ["errorType"]))
              ]))
        ])
      ]),
      (_ctx.openPopupDailyDeposit)
        ? (_openBlock(), _createBlock(_component_PopupSetorHarian, {
            key: 1,
            isPicShuttle: _ctx.isPicShuttle,
            modelValue: _ctx.openPopupDailyDeposit,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.openPopupDailyDeposit = $event)),
            detailDataCourier: _ctx.detailDataCourier,
            filterDate: _ctx.filterDateString,
            onClose: _ctx.closeDailyDeposit,
            type: _ctx.listType
          }, null, 8, ["isPicShuttle", "modelValue", "detailDataCourier", "filterDate", "onClose", "type"]))
        : _createCommentVNode("", true),
      (_ctx.openPopupAmountDue)
        ? (_openBlock(), _createBlock(_component_PopupHarusDisetor, {
            key: 2,
            modelValue: _ctx.openPopupAmountDue,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.openPopupAmountDue = $event)),
            detailDataCourier: _ctx.detailDataCourier,
            filterDate: _ctx.filterDateString,
            onDeposit: _ctx.openDailyDepositFromAmountDue,
            onClose: _ctx.closeAmountDue
          }, null, 8, ["modelValue", "detailDataCourier", "filterDate", "onDeposit", "onClose"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_WidgetDownload)
  ], 64))
}